import { render, staticRenderFns } from "./AdjuntarArchivos.vue?vue&type=template&id=cd450bb2"
import script from "./AdjuntarArchivos.vue?vue&type=script&lang=js"
export * from "./AdjuntarArchivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports